/**
 * Identifies whether the value of a measure needs to be over or under a specific threshold to be successful.
 * tag: 3058
 * @readonly
 * @enum {number} (int)
 */
export enum TestThresholdType {
  /** Under */
  Under = 0,
  /** Over */
  Over = 1,
}
